<template>
	<AppLayout title="Restablecer contraseña">
		<div class="grow flex flex-col items-center sm:justify-center">
			<img class="m-6 w-25 hidden dark:inline-block" :src="storage('/logos/SVG/white/logo.svg')" alt="Logo AArEII">
			<img class="m-6 w-25 dark:hidden" :src="storage('/logos/SVG/logo.svg')" alt="Logo AArEII">
			<div class="p-8 flex flex-col gap-8 w-full sm:w-96">
				<form class="flex flex-col items-center md:items-stretch gap-5" @submit.prevent="recover">
					<LabeledObject>
						<template #label>Dirección de correo electrónico</template>
						<input v-model="credentials.email" type="email" required autocomplete="email" autofocus>
					</LabeledObject>
					<PrimaryButton :type="ButtonType.Submit" :color="Color.TrueAArEII">
						<i class="fa-solid fa-link mr-2"/>
						Enviar enlace para restablecer la contraseña
					</PrimaryButton>
				</form>
			</div>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {Color} from '@/Types/Enums/Color'
import AppLayout from '@/Layouts/AppLayout.vue'
import {ButtonType} from '@/Types/Enums/ButtonType'
import {type Credentials} from '@/Types/Credentials'
import {type InertiaForm, useForm} from '@inertiajs/vue3'
import LabeledObject from '@/Components/LabeledObject.vue'
import PrimaryButton from '@/Components/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors, storage} from '@/helpers'

const working:Ref<boolean> = ref(false)
const credentials:InertiaForm<Partial<Credentials>> = useForm({
	email: '',
})

function recover(){
	if(!working.value){
		working.value = true
		showInfo('Enviando enlace para restablecer la contraseña...')
		credentials.post(route('password.email'), {
			onSuccess: () => {
				showSuccess('Enlace enviado correctamente.')
			},
			onError: showValidationErrors,
			onFinish: () => {
				working.value = false
			},
		})
	}
}
</script>